import { render } from "./TheData.vue?vue&type=template&id=07030aa7"
import script from "./TheData.vue?vue&type=script&lang=js"
export * from "./TheData.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__